/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import MutatorComponentBase from './MutatorComponentBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class SpriteMutator extends MutatorComponentBase
{
    @property()
    public get Execute(): boolean { return false; }
    public set Execute(value: boolean)
    {
        this.execute(this.target, [this.spriteHandler.bind(this)]);
    }

    @property({ type: cc.Node })
    protected target: cc.Node = null;

    private spriteHandler(node: cc.Node): boolean
    {
        let sprite: cc.Sprite = node.getComponent(cc.Sprite);

        if (!sprite) { return false; }

        // tslint:disable-next-line:no-string-literal
        let spriteAtlas: cc.SpriteAtlas = sprite['_atlas'];

        let success: boolean = false;
        if (!sprite.spriteFrame)
        {
            this.error(node, 'No sprite frame.');
            success = true;
        }
        else if (!spriteAtlas)
        {
            this.warn(node, 'No sprite atlas.');
            success = true;
        }

        return success;
    }
}
